export const createDirectLinksManager = (fs) => {
    return new DirectLinksImpl(fs);
};
class DirectLinksImpl {
    fs;
    constructor(fs) {
        this.fs = fs;
    }
    async generate(baseUrl, path, version) {
        return await this.fs.generateDirectLink(baseUrl, path, version);
    }
    async follow(params) {
        return await this.fs.followDirectLink(params);
    }
}
